import { getMessages } from '../../../../../../../store/constants';

export const LIST_TOOLTIP = 'List:';
export const SUBCARD_DELETE_BUTTON_TOOLTIP = getMessages().getText('card_form_subcard_delete');
